export default __webpack_public_path__ + "static/kobofunds-white-logo-d7b7c169e8b4160e2515c0827db1f64f.svg";